import React, { useMemo, useState } from "react";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Divider,
  Input,
  Row,
  Select,
  Table,
  Form,
  Tooltip,
} from "antd";
import { Link, useLocation } from "react-router-dom";

import "../../../styles/Main.scss";

const { TextArea } = Input;

const MOCK_RA = {
  raRef: "RA-2025-001",
  customerSite: "Gota Residence Project",
  status: "New – Action Required",
  receivedDate: "Today, 10:15 AM",
  requestType: "Replacement due to Damage",
  customerNotes: "QC rejected upon receipt. Surface scratches visible on all units.",
  attachments: [{ name: "Damaged_Photo_1.jpg" }],
  items: [
    {
      key: "1",
      itemName: "Basin Mixer Tap",
      supplierSku: "APEX-BM-001",
      returnQty: "5 pcs",
      customerReason: "QC Reject – Damaged",
    },
  ],
};

const SupplierAcknowledgeReturn = () => {
  const location = useLocation();
  const ra = location.state?.ra || MOCK_RA;

  const [acknowledged, setAcknowledged] = useState(false);
  const [resolution, setResolution] = useState("Send Replacement (one return shipment)");
  const [supplierNotes, setSupplierNotes] = useState(
    "Acknowledged. Please ship damaged units back via your carrier account #1234.\nReplacement order #REP-9921 created."
  );

  const disablePrimary = !acknowledged;

  const itemColumns = useMemo(
    () => [
      { title: "Item Name", dataIndex: "itemName", key: "itemName", width: 220 },
      { title: "Supplier SKU", dataIndex: "supplierSku", key: "supplierSku", width: 160 },
      { title: "Return Qty", dataIndex: "returnQty", key: "returnQty", width: 120 },
      { title: "Customer Reason", dataIndex: "customerReason", key: "customerReason" },
    ],
    []
  );

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip title="Review and acknowledge return request">
              <h3>Supplier Portal – Acknowledge Return Request ({ra.raRef || "RA-2025-001"})</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Supplier Portal</Breadcrumb.Item>
            </Breadcrumb>
           
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container aidocintak">
        <div className="FormBody">
          <div className="stepscontentwrap" style={{ padding: 0 }}>
            <div className="stepsContent" style={{ paddingRight: "5px" }}>
              <div className="formwrapper" style={{ display: "flex", flexDirection: "column" }}>
                <div className="po-good-header">
              <div className="po-header-details" style={{marginBottom: "0px"}}>
                        <div className="po-row">
                          <strong>Customer:</strong>  {ra.customerSite}
                        </div>
                        <div className="po-row">
                          <strong>Status:</strong>  {ra.status}
                        </div>
                        <div className="po-row">
                          <strong>Received:</strong>  {ra.receivedDate}
                        </div>
                      </div>
                      </div>
                <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: 0 }}>
                  <div className="returninfo-title">
                    <span className="count">1</span> Request Details &amp; Reason
                  </div>
                </Divider>

              
                      <div className="returninfo-details">
                        <div className="returninfo-row">
                          <strong>Request Type:</strong> {ra.requestType}
                        </div>
                        <div className="returninfo-row">
                          <strong>Customer Notes:</strong> {ra.customerNotes}
                        </div>
                        <div className="returninfo-row">
                          <strong>Attachment preview:</strong>
                        </div>
                        <div className="returninfo-row muted-text">
                          {ra.attachments?.length ? ra.attachments[0].name : "No attachments"}
                        </div>
                      </div>
                   
                   
                 
          

                <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: 0 }}>
                  <div className="returninfo-title">
                    <span className="count">2</span> Items for Return
                  </div>
                </Divider>

                <div className="tablewrp" style={{ paddingLeft: "34px", marginTop: "10px", marginBottom: "16px" }}>
                  <Table
                    rowKey="key"
                    columns={itemColumns}
                    dataSource={ra.items}
                    pagination={false}
                    size="small"
                    scroll={{ x: 700 }}
                  />
                </div>

                <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: 0 }}>
                  <div className="returninfo-title">
                    <span className="count">3</span> Supplier Acknowledgement &amp; Resolution
                  </div>
                </Divider>

                <div style={{ paddingLeft: "34px", marginTop: "10px", marginBottom: "16px" }}>
                <Checkbox
                        checked={acknowledged}
                        onChange={(e) => setAcknowledged(e.target.checked)} style={{fontSize: "14px", fontWeight: 600, marginBottom:'16px'}}
                      >
                        I acknowledge the issue and authorize the return
                      </Checkbox>
                      <Form>
<Row gutter={[15]}>
  <Col
    xs={16}
    sm={16}
    md={6}
    lg={6}
    xl={6}
    className="TextFeild gutter-row"
  >
    <Form.Item label="Proposed Resolution" name="targetLocation">
    <Select
                        value={resolution}
                        onChange={setResolution}
                        options={[
                          {
                            label: "Send Replacement (one return shipment)",
                            value: "Send Replacement (one return shipment)",
                          },
                          { label: "Issue Credit Note", value: "Issue Credit Note" },
                          {
                            label: "Partial Replacement + Credit",
                            value: "Partial Replacement + Credit",
                          },
                        ]}
                        style={{ width: "100%" }}
                      />
    </Form.Item>
  </Col>
  <Col xs={24}>
    <Form.Item label="Supplier Notes to Customer" name="buyerNotes">
    <TextArea
                        rows={4}
                        value={supplierNotes}
                        onChange={(e) => setSupplierNotes(e.target.value)}
                        placeholder="Acknowledged. Please ship damaged units back via your carrier account #1234. Replacement order #REP-9921 created."
                      />
    </Form.Item>
  </Col>
</Row>
</Form>
                   
                  
                
                </div>
              </div>
            </div>

            <div className="FormFooter">
              <div />
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <Button
                  type="primary"
                  className="rejectBtn"
                  onClick={() => {
                    // eslint-disable-next-line no-console
                    console.log("Reject Request", { ra });
                  }}
                >
                  Reject Request
                </Button>
                <Button
                  type="primary"
                  className="SaveGradiantBtn"
                  disabled={disablePrimary}
                  onClick={() => {
                    // eslint-disable-next-line no-console
                    console.log("Acknowledge & Authorize Return", {
                      ra,
                      acknowledged,
                      resolution,
                      supplierNotes,
                    });
                  }}
                >
                  Acknowledge &amp; Authorize Return
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SupplierAcknowledgeReturn;